// extracted by mini-css-extract-plugin
export default {"root":"FollowBtn_root__KOw5+"};